<template>
  <div>
    <div id="collection" class="container">
      <section>
        <!-- 合集列表 -->
        <div class="collection-list section-group">
          <div class="row">
            <div class="col-12">
              <h2 class="section-title">{{$t('Album.collectionlist.Setlist')}}</h2>
              <div class="row">
                <div
                  class="col-6 col-md-4 col-lg-3 col-xl-2"
                  v-for="item in pageData"
                  :key="item.id"
                >
                  <div class="album-card card">
                    <router-link
                      :to="{ name: 'collection', query: { id: item.id } }"
                    >
                      <singleCollectionVue
                        :props_img="item.sgL_ImageUrl"
                        :props_title="item.sgL_PhotoName"
                        :props_date="item.sgL_PG_CAddTimerF"
                        :props_num="item.sgL_PhotoCount"
                      ></singleCollectionVue>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="row page">
                <div class="col">
                  <pagination
                    v-if="pageData != null && pageData.length > 0"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    :hide-on-single-page="true"
                    :pageSizes="pageParams.pageSizes"
                    @handleCurrentChange="handleCurrent"
                    @handleSizeChange="handleSize"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.合集列表 -->
      </section>
    </div>
  </div>
</template>
<script>
import singleCollectionVue from "./singleCollection.vue";
import pagination from "../common/Page";

export default {
  components: {
    singleCollectionVue,
    pagination,
  },
  data() {
    return {
      pageData: [],
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageSizes: [3, 6, 12, 24],
      },
    };
  },
  created() {
    this.urlCheck();
    this.getPageData();
  },
  methods: {
    urlCheck() {
      if (this.$route.query.currentPage) {
        this.pageParams.currentPage = Number(this.$route.query.currentPage);
      }
      if (this.$route.query.currentSize) {
        this.pageParams.limit = Number(this.$route.query.currentSize);
      }
    },
    getPageData() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.$api.albumApi.PhotoCollectionGetAll(params).then((res) => {
        if (res.data.success) {
          this.pageData = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    handleCurrent(val) {
      this.pageParams.currentPage = val;
      this.getPageData();
      this.pageRemeber();
    },
    handleSize(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getPageData();
      this.pageRemeber();
    },
    pageRemeber() {
      this.historyPushState(
        this.setUrlPar({
          currentPage: this.pageParams.currentPage,
          currentSize: this.pageParams.limit,
        })
      );
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.page >>> .el-pagination__total {
  color: initial !important;
}
.page >>> .el-pagination__jump {
  color: initial !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Album/collectionlist.vue